import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import SolicitorHomePage from "../../components/solicitorHomePage";
import {
requestGetArticleAttachment,
requestGetArticlesSolicitorHomePage
} from "../../actions/articlesList";
import { push } from "connected-react-router";
import { _getFileFromBase64 } from "../../helpers/functions";
import { isAgent } from "../../helpers/functions";

const SolicitorHomePageHOC = () => {
    const dispatch = useDispatch();
    
    // Select state values using useSelector
    const userRoles = useSelector(state => state.user.loggedInUser.roles);
    const solicitorArticlesList = useSelector(state => state.solicitorArticlesList);
    const failedToReceivePendingTobaMsg = useSelector(state => state.user.failedToReceivePendingTobaMsg);
    const articlesList = useSelector(state => state.articlesList);

    // Action handlers using useDispatch
    const handleRequestGetArticlesSolicitorHomePage = (payload) => {
        dispatch(requestGetArticlesSolicitorHomePage(payload));
    };

    const handlePush = (url) => {
        dispatch(push(url));
    };

    const handleRequestGetArticleAttachment = (payload) => {
        dispatch(requestGetArticleAttachment(payload));
    };

    // Replace componentWillMount with useEffect
    useEffect(() => {
        let parameters = {
            limit: 3,
            offset: 0,
            published: true,
            unpublished: false,
            search: null
        };
        
        if (isAgent(userRoles)) {
            handleRequestGetArticlesSolicitorHomePage(parameters);
        }
    }, []); // Empty dependency array = run once on mount

    // Render conditionally based on user role
    if (!isAgent(userRoles)) {
        return null;
    }

    return (
        <SolicitorHomePage
            requestGetArticleAttachment={handleRequestGetArticleAttachment}
            failedToReceivePendingTobaMsg={failedToReceivePendingTobaMsg}
            push={handlePush}
            articles={solicitorArticlesList.homePageArticles}
        />
    );
};

export default SolicitorHomePageHOC;